import { render, staticRenderFns } from "./orderBody.vue?vue&type=template&id=2a17fbd4&scoped=true"
import script from "./orderBody.vue?vue&type=script&lang=js"
export * from "./orderBody.vue?vue&type=script&lang=js"
import style0 from "./orderBody.vue?vue&type=style&index=0&id=2a17fbd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17fbd4",
  null
  
)

export default component.exports